export const VIEWPORT_KEY = '@@viewport';

export const ActionTypes = {
    SET_DEVICE_TYPE: `${VIEWPORT_KEY}/SET_DEVICE_TYPE`,
};

export const DEVICE_TYPES = {
    Desktop: 'desktop',
    Mobile: 'mobile',
    Tablet: 'tablet',
};
